"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerWindow;

var _ownerDocument = _interopRequireDefault(require("./ownerDocument"));

function ownerWindow(node) {
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || window;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/utils/ownerWindow.js
// module id = 181
// module chunks = 0